import { PlatformAPI } from "@shapr3d/frontend-lib";
import { create } from "zustand";

import { localStorageKeys } from "../config";

interface DeepLinkStateStore {
  isAutoOpenEnabled: boolean;
  setIsAutoOpenEnabled: (enabled: boolean) => void;
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  reset: () => void;
}

const getInitialIsAutoOpenEnabled = () =>
  PlatformAPI.getInstance().isShaprSupportedPlatform() &&
  localStorage.getItem(localStorageKeys.isDeepLinkAutoOpenEnabled) === "true";

export const useDeepLinkStateStore = create<DeepLinkStateStore>((set) => ({
  isAutoOpenEnabled: getInitialIsAutoOpenEnabled(),
  setIsAutoOpenEnabled: (isAutoOpenEnabled) => {
    localStorage.setItem(localStorageKeys.isDeepLinkAutoOpenEnabled, String(isAutoOpenEnabled));
    set((state) => ({ ...state, isAutoOpenEnabled }));
  },
  isModalOpen: getInitialIsAutoOpenEnabled(),
  setIsModalOpen: (isModalOpen) => set((state) => ({ ...state, isModalOpen })),
  reset: () => {
    set({
      isAutoOpenEnabled: getInitialIsAutoOpenEnabled(),
      isModalOpen: getInitialIsAutoOpenEnabled(),
    });
  },
}));
